module.exports = __webpack_public_path__ + "static/img/6.d4bd230.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/list/6.png
// module id = tg0m
// module chunks = 1